export default {
    availableLocales: [
        "fr"
    ],
}